import SwitchToTraqqDiscount from '@components/Ads/SwitchToTraqqDiscount'
import Card from '@components/Card';
import Grid from '@components/Grid';
import Info from '@components/Info';
import MailResponse from '@components/MailResponse';
import Section, { SectionHeadline } from '@components/Section';
import Alert from '@components/UI/Alert';
import Button from '@components/UI/Button';
import Container from '@components/UI/Container';
import Field, { FieldFeedback, FieldLabel } from '@components/UI/Field';
import Input from '@components/UI/Input';
import FileUploader from '@components/UI/Input/FileUploader';
import Loading from '@components/UI/Loading';
import Picture from '@components/UI/Picture';
import Heading from '@components/UI/Typography/Heading';
import Paragraph from '@components/UI/Typography/Paragraph';

import discount40OffImage from '@images/dont-worry-about-onboarding.png';

import { Navigation } from "@layouts/NavigationV2"
import { objectToFormData } from '@utils/form';
import RenderIf from '@utils/renderIf';

import React, { useLayoutEffect, useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha';
import { useRouter } from "next/router";

const SwitchToTraqqPage = () => {
    const recaptchaRef = useRef(null);
    const router = useRouter();

    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const [response, setResponse] = useState({});
    const [errors, setErrors] = useState({});

    const [files, setFiles] = useState({});

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (Object.keys(files).length == 0 && (Array.isArray(errors?.purchaseFile) && errors?.purchaseFile?.length > 0)) {
            setLoading(false);
            return;
        }

        if(!loading) {
            setLoading(true);
            setSent(false);

            const formData = objectToFormData(event.target);
            formData.append('recaptcha', await recaptchaRef.current.executeAsync());
            formData.append('purchaseFile', files[0]);

            try {
                const response = await fetch(
                  `${process.env.NEXT_PUBLIC_APP_URL}/api/v1/request-discount`,
                    {
                        method: "POST",
                        // headers: {
                        //     'X-Requested-With': 'XMLHttpRequest',
                        //     'X-CSRF-TOKEN': token
                        // },
                        body: formData,
                    }
                );

                const status = response.status;

                if (status === 200) {
                  const data = await response.json();

                  if (data.result == "success") {
                    setResponse(data.params);
                    setErrors({});
                    setSent(true);

                    event.target.reset();
                  } else {
                    setErrors(data.data.errors);
                  }
                } else if (status === 400) {
                  router.push("/400");
                } else if (status === 500) {
                  router.push("/500");
                }
                setLoading(false);
              } catch (error) {
                router.push("/500");
              }
        }
    };

    const handleFilesSelect = async (selectedFiles = null) => {
        if (selectedFiles != null) {
          setErrors({});
          setFiles(selectedFiles);
          recaptchaRef.current.reset();
        }
    };

    /*useLayoutEffect(() => {
        document.querySelector('#button-login').classList.add('max-768:text-violet-700', '768:max-1024:text-neutral-900')

        return () => {
            document.querySelector('#button-login').classList.remove('max-768:text-violet-700', '768:max-1024:text-neutral-900')
        }
    }, [])*/

    return (
        <>
            <Navigation
                staticTheme="light"
                actionTheme="light"
            />

            <Container>
                <Section
                    mods={ {
                        'switch-to-traqq': true
                    } }
                    className='!overflow-visible !pt-0 max-768:!m-0 768:mt-20p 1024:mt-30p 1280:mt-50p'
                >
                    <Grid
                        xs={ 1 }
                        md={ 2 }
                        items='center'
                        className='gap-24p'
                    >
                        <Info>
                            <span
                                className='text-mob-h1 1024:text-desk-h2 1280:text-desk-h1'
                            >
                                Using a different time tracker? Switch to Traqq and get a discount
                            </span>
                            <Paragraph
                                tag='p'
                                size='lg'
                            >
                                Using a different time tracker or employee monitoring software? Switch to Traqq and get a 30% discount on annual subscription, for a whole year.
                            </Paragraph>
                        </Info>

                        <SwitchToTraqqDiscount />
                    </Grid>
                </Section>

                <Section>
                    <Grid
                        xs={ 1 }
                        md={ 2 }
                        items='center'
                        gx={ 16 }
                        gy={ 6 }
                    >
                        <Picture
                            image={ discount40OffImage }
                            alt='Don’t worry about onboarding!'
                            order='last'
                        />

                        <Info>
                            <Heading
                                tag='h2'
                            >
                                Don’t worry about onboarding!
                            </Heading>

                            <Paragraph
                                tag='p'
                                size='lg'
                            >
                                Starting with Traqq will be a breeze. Our dedicated managers will make the transition smooth for you so you’ll have no distractions.
                            </Paragraph>
                        </Info>
                    </Grid>
                </Section>

                <Section>
                    <Grid
                        xs={ 1 }
                        md={ 3 }
                        gy={ 12 }
                    >
                        <Card
                            mods={ { center: true } }
                            image={
                                // eslint-disable-next-line @next/next/no-img-element
                                <img
                                    // eslint-disable-next-line max-len
                                    src='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTIiIGhlaWdodD0iMTEyIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjRjk1ODQyIiBkPSJNMTA2LjY2IDM4LjIzYzYuNzEtMjEuMTYtMTIuOS00MS4yNi0zNC4yNS0zNS4xTDI0LjEyIDE3LjA3QzQuOSAyMi42Mi0yLjM2IDQ2LjAyIDEwLjM3IDYxLjQ1bDMxLjY4IDM4LjQyYzE0LjAzIDE3IDQxLjM1IDExLjcyIDQ4LTkuMjhsMTYuNjEtNTIuMzZaIi8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTQ5LjEzIDQ4LjAzVjQwLjNoMTIuOTRWNzFoLTguNlY0OC4wM2gtNC4zNFoiLz48L3N2Zz4='
                                    alt='Fill out the form'
                                    width={ 112 }
                                    height={ 112 }
                                />
                            }
                            body={ {
                                title: (
                                    <Heading
                                        tag='h3'
                                    >
                                        Fill out the form
                                    </Heading>
                                ),

                                text: (
                                    <Paragraph
                                        size='lg'
                                    >
                                        Give us some details on your subscription with the other time tracker.
                                    </Paragraph>
                                )
                            } }
                        />

                        <Card
                            mods={ { center: true } }
                            image={
                                // eslint-disable-next-line @next/next/no-img-element
                                <img
                                    // eslint-disable-next-line max-len
                                    src='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTIiIGhlaWdodD0iMTEyIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjMjBDMjg4IiBkPSJNMjkuOTUgNy4wM0M3Ljg4IDYuMDMtNi4zOSAzMC4wMSA1LjAzIDQ4LjkxbDI1LjgyIDQyLjczYzEwLjI5IDE3LjAyIDM0LjY1IDE3Ljk2IDQ2LjIgMS43OGwyOC43Ny00MC4yNmMxMi43My0xNy44My42Mi00Mi42OC0yMS4yOC00My42NkwyOS45NSA3LjAzWiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik00NS40MyA2NC40YzIuNzItMi4xMiA0Ljk0LTMuOTYgNi42OC01LjVhMjkuNjIgMjkuNjIgMCAwIDAgNC4zNy00Ljc0YzEuMTctMS42NSAxLjc2LTMuMjIgMS43Ni00LjcgMC0uOS0uMjEtMS42LS42My0yLjEtLjQtLjUtLjk4LS43Ni0xLjc2LS43Ni0uODIgMC0xLjQ1LjM1LTEuOSAxLjA1YTUuMiA1LjIgMCAwIDAtLjYyIDIuOThoLTcuOThjLjA4LTIuNS42My00LjU1IDEuNjMtNi4xN2E5LjA2IDkuMDYgMCAwIDEgMy45NS0zLjYyIDEyLjMgMTIuMyAwIDAgMSA1LjQyLTEuMTdjMy40NCAwIDYgLjg1IDcuNjkgMi41NmE5LjA2IDkuMDYgMCAwIDEgMi41MiA2LjY0YzAgMi45LS45OCA1LjY0LTIuOTQgOC4xOWEzMS41NCAzMS41NCAwIDAgMS03LjI3IDYuODRoMTAuNXY2LjY4SDQ1LjQzdi02LjE3WiIvPjwvc3ZnPg=='
                                    alt='Get your coupon'
                                    width={ 112 }
                                    height={ 112 }
                                />
                            }
                            body={ {
                                title: (
                                    <Heading
                                        tag='h3'
                                    >
                                        Get your coupon
                                    </Heading>
                                ),

                                text: (
                                    <Paragraph
                                        size='lg'
                                    >
                                        We will offer you a discount to help you benefit from the switch even more.
                                    </Paragraph>
                                )
                            } }
                        />

                        <Card
                            mods={ { center: true } }
                            image={
                                // eslint-disable-next-line @next/next/no-img-element
                                <img
                                    // eslint-disable-next-line max-len
                                    src='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTIiIGhlaWdodD0iMTEyIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjNjc2QkQyIiBkPSJNMTYuMjMgNDEuNkMtMS41IDU0LjY0IDIuNDcgODIuMTggMjMuMTUgODkuN2w0Ni43NyAxNy4wMmMxOC42MyA2Ljc4IDM4LjEtNy43MyAzNi45Mi0yNy41bC0yLjkyLTQ5LjI1QzEwMi42MiA4LjE3IDc3LjY4LTMuNTQgNjAuMDggOS40TDE2LjIzIDQxLjZaIi8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTQ1LjIgNDkuNDVjLjExLTMuMTYgMS4xLTUuNTggMi45NC03LjI2IDEuODUtMS43IDQuNDItMi41NiA3LjczLTIuNTYgMi4xNSAwIDMuOTkuMzggNS41IDEuMTNhNy45IDcuOSAwIDAgMSAzLjQ4IDMuMDIgNy45NCA3Ljk0IDAgMCAxIDEuMTggNC4yOWMwIDEuOS0uNDYgMy40My0xLjM5IDQuNThhNi45MyA2LjkzIDAgMCAxLTMuMTUgMi4yN3YuMTZjMy40IDEuMjYgNS4wOSAzLjY3IDUuMDkgNy4yM2E4LjI0IDguMjQgMCAwIDEtNC43NSA3LjgxIDEyLjM3IDEyLjM3IDAgMCAxLTUuNSAxLjEzYy0zLjUgMC02LjI3LS44NC04LjMyLTIuNTItMi4wMS0xLjctMy4wNi00LjMtMy4xNS03LjhoOC4wMmMtLjA1IDEuMTEuMTkgMS45OC43MiAyLjYuNTMuNjEgMS4zMy45MiAyLjQuOTJhMi40IDIuNCAwIDAgMCAxLjg4LS43NmMuNDgtLjUuNzItMS4xNy43Mi0yLjAxIDAtMS4wNy0uMzUtMS44NS0xLjA1LTIuMzUtLjY4LS41LTEuNzgtLjc2LTMuMzItLjc2aC0xLjQ3di02LjY4aDEuNDNhNS42MyA1LjYzIDAgMCAwIDIuNjgtLjVjLjc2LS40IDEuMTQtMS4xNiAxLjE0LTIuMzEgMC0uODctLjIxLTEuNTItLjYzLTEuOTMtLjQyLS40NS0xLS42OC0xLjcyLS42OC0uODIgMC0xLjQyLjMtMS44Ljg4YTQuMzIgNC4zMiAwIDAgMC0uNjQgMi4xSDQ1LjJaIi8+PC9zdmc+'
                                    alt='Apply your discount'
                                    width={ 112 }
                                    height={ 112 }
                                />
                            }
                            body={ {
                                title: (
                                    <Heading
                                        tag='h3'
                                    >
                                        Apply your discount
                                    </Heading>
                                ),

                                text: (
                                    <Paragraph
                                        size='lg'
                                    >
                                        Save on your Traqq plan and enjoy the best time tracking tool out there!
                                    </Paragraph>
                                )
                            } }
                        />
                    </Grid>
                </Section>
            </Container>

            <Section>
                { /* TODO: come up with component for the form */ }
                <form
                    method='POST'
                    className='py-14 border-y-4 border-violet-900 lg:w-[800px] lg:mx-auto md:mx-auto md:border-4 md:rounded-2xl md:w-[706px] md:px-12'
                    acceptCharset='UTF-8'
                    onSubmit={ handleSubmit }
                >
                    <Container
                        mods={ { 'no-spacing': true } }
                    >
                        <SectionHeadline
                            gap={ 4 }
                            mods={ { center: true } }
                        >
                            <Heading
                                tag='h2'
                            >
                                Request a discount
                            </Heading>

                            <Paragraph
                                tag='p'
                            >
                                Please fill out the from below and someone from Traqq will respond soon.
                            </Paragraph>
                        </SectionHeadline>

                        <Field>
                            <FieldLabel
                                htmlFor='timeTracker'
                            >
                                Your current time tracker*
                            </FieldLabel>

                            <Input
                                name='timeTracker'
                                type='text'
                                placeholder='Hubstaff'
                                id='timeTracker'
                                required
                                mods={ { invalid: Boolean(errors.timeTracker) } }
                                inputProps={ { maxLength: 64 } }
                            />


                            <RenderIf
                                isTrue={ errors.timeTracker }
                            >
                                <FieldFeedback
                                    invalid
                                >
                                    { errors.timeTracker?.join('\n') }
                                </FieldFeedback>
                            </RenderIf>
                        </Field>

                        <Field>
                            <FieldLabel
                                htmlFor='purchaseFile'
                            >
                                Proof of purchase: screenshot of your receipt, paid invoice, license code, etc*
                            </FieldLabel>

                            <FileUploader
                                id='purchaseFile'
                                errors={ errors }
                                filesUpload={handleFilesSelect}
                            />
                        </Field>

                        <Grid
                            xs={ 1 }
                            md={ 2 }
                            gx={ 6 }
                        >
                            <Field>
                                <FieldLabel
                                    htmlFor='fullName'
                                >
                                    Full Name*
                                </FieldLabel>

                                <Input
                                    name='fullName'
                                    type='text'
                                    placeholder='John Doe'
                                    id='fullName'
                                    required
                                    mods={ { invalid: Boolean(errors.fullName) } }
                                    inputProps={ { maxLength: 64 } }
                                />

                                <RenderIf
                                    isTrue={ errors.fullName }
                                >
                                    <FieldFeedback
                                        invalid
                                    >
                                        { errors.fullName?.join('\n') }
                                    </FieldFeedback>
                                </RenderIf>
                            </Field>

                            <Field>
                                <FieldLabel
                                    htmlFor='email'
                                >
                                    Work email address*
                                </FieldLabel>

                                <Input
                                    name='email'
                                    type='email'
                                    placeholder='email@domain.com'
                                    id='email'
                                    required
                                    mods={ { invalid: Boolean(errors.email) } }
                                    inputProps={ { maxLength: 64 } }
                                />

                                <RenderIf
                                    isTrue={ errors.email }
                                >
                                    <FieldFeedback
                                        invalid
                                    >
                                        { errors.email?.join('\n') }
                                    </FieldFeedback>
                                </RenderIf>
                            </Field>
                        </Grid>

                        <Field>
                            <FieldLabel
                                htmlFor='message'
                            >
                                Your message*
                            </FieldLabel>

                            <Input
                                name='message'
                                type='textarea'
                                placeholder='Type here...'
                                id='message'
                                rows={ 3 }
                                required
                                mods={ { invalid: Boolean(errors.message) } }
                                inputProps={ { maxLength: 2000 } }
                            />

                            <RenderIf
                                isTrue={ errors.message }
                            >
                                <FieldFeedback
                                    invalid
                                >
                                    { errors.message?.join('\n') }
                                </FieldFeedback>
                            </RenderIf>
                        </Field>

                        <div className='mb-8'></div>

                        <ReCAPTCHA
                            ref={ recaptchaRef }
                            sitekey={ process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY }
                            size='invisible'
                        />

                        <RenderIf
                            isTrue={ errors.recaptcha }
                        >
                            <Alert
                                severity='danger'
                            >
                                { errors.recaptcha?.join('\n') }
                            </Alert>
                        </RenderIf>

                        <Button
                            type='submit'
                            variant='primary'
                            mods={ { block: true } }
                        >
                            { loading ? <Loading /> : 'Request my discount' }
                        </Button>
                    </Container>
                </form>
            </Section>

            <RenderIf
                isTrue={ sent }
            >
                <MailResponse
                    title={ response.title }
                    body={ response.body }
                />
            </RenderIf>
        </>
    );
};

export default SwitchToTraqqPage;
